import { styled } from "styled-components";

export const ReviewFormDiv = styled.div`
  // border: 2px solid black;
  display: flex;
  justify-content: start;
  align-items: center;
  margin-left: 20px;
`;
